
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const productMainRouter: Array<RouteRecordRaw> = [
  {
    path: '/product',
    name: 'printer',
    component: Layout,
    redirect: 'noredirect',
    meta: {
      title: 'product',
      icon: '#iconyijicaidan'
    },
    children: [
      {
        path: 'printerMagage',
        name: 'printerMagage',
        component: () => import(/* webpackChunkName: "redirect" */ '@/views/module/product/Index.vue'),
        meta: {
          title: 'printerMagage',
          icon: '#iconyijicaidan'
        },
        children: [
          {
            path: '/product/printerCategory/index',
            component: () => import(/* webpackChunkName: "printerCategory" */ '@/views/module/product/printerCategory/index.vue'),
            name: 'vcPrinterCategory',
            meta: {
              title: 'printerCategory',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcPrinterCategory']
            }
          },
          {
            path: '/product/printer/index',
            component: () => import(/* webpackChunkName: "printer" */ '@/views/module/product/printer/index.vue'),
            name: 'vcPrinter',
            meta: {
              title: 'printer',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcProduct']
            }
          },
          {
            path: '/product/printerMaterials/index',
            component: () => import(/* webpackChunkName: "printerMaterials" */ '@/views/module/product/printerMaterials/index.vue'),
            name: 'vcPrinterMaterials',
            meta: {
              title: 'printerMaterials',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcPrinterMaterials']
            }
          }
        ]
      },
      {
        path: 'materialMagage',
        name: 'materialMagage',
        component: () => import(/* webpackChunkName: "redirect" */ '@/views/module/product/Index.vue'),
        meta: {
          title: 'materialMagage',
          icon: '#iconyijicaidan'
        },
        children: [
          {
            path: '/product/materialCategory/index',
            component: () => import(/* webpackChunkName: "materialCategory" */ '@/views/module/product/materialCategory/index.vue'),
            name: 'vcMaterialCategory',
            meta: {
              title: 'materialCategory',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcMaterialCategory']
            }
          },
          {
            path: '/product/materialCategoryLanguage/index',
            component: () => import(/* webpackChunkName: "materialCategoryLanguage" */ '@/views/module/product/materialCategoryLanguage/index.vue'),
            name: 'vcMaterialCategoryLanguage',
            meta: {
              title: 'materialCategoryLanguage',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcMaterialCategoryLanguage']
            }
          },
          {
            path: '/product/materialType/index',
            component: () => import(/* webpackChunkName: "materialType" */ '@/views/module/product/materialType/index.vue'),
            name: 'vcMaterialType',
            meta: {
              title: 'materialType',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcMaterialType']
            }
          },
          {
            path: '/product/material/index',
            component: () => import(/* webpackChunkName: "material" */ '@/views/module/product/material/index.vue'),
            name: 'vcMaterial',
            meta: {
              title: 'material',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcMaterial']
            }
          },
          {
            path: '/product/materialAttributeDef/index',
            component: () => import(/* webpackChunkName: "materialAttributeDef" */ '@/views/module/product/materialAttributeDef/index.vue'),
            name: 'vcMaterialAttributeDef',
            meta: {
              title: 'materialAttributeDef',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcMaterialAttributeDef']
            }
          },
          {
            path: '/product/materialAttributeValue/index',
            component: () => import(/* webpackChunkName: "materialAttributeValue" */ '@/views/module/product/materialAttributeValue/index.vue'),
            name: 'vcMaterialAttributeValue',
            meta: {
              title: 'materialAttributeValue',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcMaterialAttributeValue']
            }
          },
          {
            path: '/product/paperColorDef/index',
            component: () => import(/* webpackChunkName: "paperColorDef" */ '@/views/module/product/paperColorDef/index.vue'),
            name: 'vcPaperColorDef',
            meta: {
              title: 'paperColorDef',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcPaperColorDef']
            }
          },
          {
            path: '/product/paperTextureDef/index',
            component: () => import(/* webpackChunkName: "paperTextureDef" */ '@/views/module/product/paperTextureDef/index.vue'),
            name: 'vcPaperTextureDef',
            meta: {
              title: 'paperTextureDef',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcPaperTextureDef']
            }
          },
          {
            path: '/product/ribbonColorDef/index',
            component: () => import(/* webpackChunkName: "ribbonColorDef" */ '@/views/module/product/ribbonColorDef/index.vue'),
            name: 'vcRibbonColorDef',
            meta: {
              title: 'ribbonColorDef',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcRibbonColorDef']
            }
          },
          {
            path: '/product/materialCategoryUser/index',
            component: () => import(/* webpackChunkName: "materialCategoryUser" */ '@/views/module/product/materialCategoryUser/index.vue'),
            name: 'vcMaterialCategoryUser',
            meta: {
              title: 'materialCategoryUser',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcMaterialCategoryUser']
            }
          }
        ]
      },
      {
        path: 'templateMagage',
        name: 'templateMagage',
        component: () => import(/* webpackChunkName: "redirect" */ '@/views/module/product/Index.vue'),
        meta: {
          title: 'templateMagage',
          icon: '#iconyijicaidan'
        },
        children: [
          {
            path: '/product/industryAndCategory/index',
            component: () => import(/* webpackChunkName: "industryAndCategory" */ '@/views/module/product/industryAndCategory/index.vue'),
            name: 'vcIndustryAndCategory',
            meta: {
              title: 'industryAndCategory',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcIndustryAndCategory']
            }
          },
          {
            path: '/product/industryAndCategoryLanguage/index',
            component: () => import(/* webpackChunkName: "industryAndCategoryLanguage" */ '@/views/module/product/industryAndCategoryLanguage/index.vue'),
            name: 'vcIndustryAndCategoryLanguage',
            meta: {
              title: 'industryAndCategoryLanguage',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcIndustryAndCategoryLanguage']
            }
          },
          {
            path: '/product/templatePreset/index',
            component: () => import(/* webpackChunkName: "templatePreset" */ '@/views/module/product/templatePreset/index.vue'),
            name: 'vcTemplatePreset',
            meta: {
              title: 'templatePreset',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcTemplatePreset']
            }
          },
          {
            path: '/product/templateCategoryUser/index',
            component: () => import(/* webpackChunkName: "templateCategoryUser" */ '@/views/module/product/templateCategoryUser/index.vue'),
            name: 'vcTemplateCategoryUser',
            meta: {
              title: 'templateCategoryUser',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcTemplateCategoryUser']
            }
          },
          {
            path: '/product/templateUser/index',
            component: () => import(/* webpackChunkName: "templateUser" */ '@/views/module/product/templateUser/index.vue'),
            name: 'vcTemplateUser',
            meta: {
              title: 'templateUser',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcTemplateUser']
            }
          }
        ]
      },
      {
        path: 'appMagage',
        name: 'appMagage',
        component: () => import(/* webpackChunkName: "redirect" */ '@/views/module/product/Index.vue'),
        meta: {
          title: 'appMagage',
          icon: '#iconyijicaidan'
        },
        children: [
          {
            path: '/product/application/index',
            component: () => import(/* webpackChunkName: "application" */ '@/views/module/product/application/index.vue'),
            name: 'vcApplication',
            meta: {
              title: 'application',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcApplication']
            }
          },
          {
            path: '/product/applicationVersion/index',
            component: () => import(/* webpackChunkName: "applicationVersion" */ '@/views/module/product/applicationVersion/index.vue'),
            name: 'vcApplicationVersion',
            meta: {
              title: 'applicationVersion',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcApplicationVersion']
            }
          },
          {
            path: '/product/applicationPrinters/index',
            component: () => import(/* webpackChunkName: "applicationPrinters" */ '@/views/module/product/applicationPrinters/index.vue'),
            name: 'vcApplicationPrinters',
            meta: {
              title: 'applicationPrinters',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcApplicationPrinters']
            }
          }
        ]
      },
      {
        path: 'appResourceMagage',
        name: 'appResourceMagage',
        component: () => import(/* webpackChunkName: "redirect" */ '@/views/module/product/Index.vue'),
        meta: {
          title: 'appResourceMagage',
          icon: '#iconyijicaidan'
        },
        children: [
          {
            path: '/product/labelIconCategory/index',
            component: () => import(/* webpackChunkName: "labelIconCategory" */ '@/views/module/product/labelIconCategory/index.vue'),
            name: 'vcLabelIconCategory',
            meta: {
              title: 'labelIconCategory',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcLabelIconCategory']
            }
          },
          {
            path: '/product/labelIconCategoryLanguage/index',
            component: () => import(/* webpackChunkName: "labelIconCategoryLanguage" */ '@/views/module/product/labelIconCategoryLanguage/index.vue'),
            name: 'vcLabelIconCategoryLanguage',
            meta: {
              title: 'labelIconCategoryLanguage',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcLabelIconCategoryLanguage']
            }
          },
          {
            path: '/product/labelIcon/index',
            component: () => import(/* webpackChunkName: "labelIcon" */ '@/views/module/product/labelIcon/index.vue'),
            name: 'vcLabelIcon',
            meta: {
              title: 'labelIcon',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcLabelIcon']
            }
          },
          {
            path: '/product/labelFrameCategory/index',
            component: () => import(/* webpackChunkName: "labelFrameCategory" */ '@/views/module/product/labelFrameCategory/index.vue'),
            name: 'vcLabelFrameCategory',
            meta: {
              title: 'labelFrameCategory',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcLabelFrameCategory']
            }
          },
          {
            path: '/product/labelFrameCategoryLanguage/index',
            component: () => import(/* webpackChunkName: "labelFrameCategoryLanguage" */ '@/views/module/product/labelFrameCategoryLanguage/index.vue'),
            name: 'vcLabelFrameCategoryLanguage',
            meta: {
              title: 'labelFrameCategoryLanguage',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcLabelFrameCategoryLanguage']
            }
          },
          {
            path: '/product/labelFrame/index',
            component: () => import(/* webpackChunkName: "labelFrame" */ '@/views/module/product/labelFrame/index.vue'),
            name: 'vcLabelFrame',
            meta: {
              title: 'labelFrame',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcLabelFrame']
            }
          },
          {
            path: 'tags/index',
            component: () => import(/* webpackChunkName: "tags" */ '@/views/module/product/tags/index.vue'),
            name: 'vcTags',
            meta: {
              title: 'tags',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcTags']
            }
          },
          {
            path: '/product/fonts/index',
            component: () => import(/* webpackChunkName: "fonts" */ '@/views/module/product/fonts/index.vue'),
            name: 'vcFonts',
            meta: {
              title: 'fonts',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcFonts']
            }
          }
        ]
      },
      {
        path: 'appUserMagage',
        name: 'appUserMagage',
        component: () => import(/* webpackChunkName: "redirect" */ '@/views/module/product/Index.vue'),
        meta: {
          title: 'appUserMagage',
          icon: '#iconyijicaidan'
        },
        children: [
          {
            path: '/product/userList/index',
            component: () => import(/* webpackChunkName: "userList" */ '@/views/module/product/userList/index.vue'),
            name: 'vcUserList',
            meta: {
              title: 'userList',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcUserList']
            }
          },
          {
            path: '/product/shoppingAddress/index',
            component: () => import(/* webpackChunkName: "shoppingAddress" */ '@/views/module/product/shoppingAddress/index.vue'),
            name: 'vcShoppingAddress',
            meta: {
              title: 'shoppingAddress',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcShoppingAddress']
            }
          },
          {
            path: '/product/shoppingInvoice/index',
            component: () => import(/* webpackChunkName: "shoppingInvoice" */ '@/views/module/product/shoppingInvoice/index.vue'),
            name: 'vcShoppingInvoice',
            meta: {
              title: 'shoppingInvoice',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcShoppingInvoice']
            }
          },
          {
            path: '/product/labelHistory/index',
            component: () => import(/* webpackChunkName: "labelHistory" */ '@/views/module/product/labelHistory/index.vue'),
            name: 'vcLabelHistory',
            meta: {
              title: 'labelHistory',
              icon: '#iconcaidanitem',
              roles: ['MENU_vcLabelHistory']
            }
          }
        ]
      },
      {
        path: 'customer/index',
        component: () => import(/* webpackChunkName: "customer" */ '@/views/module/product/customer/index.vue'),
        name: 'vcCustomer',
        meta: {
          title: 'customer',
          icon: '#iconcaidanitem',
          roles: ['MENU_vcCustomer']
        }
      },
      {
        path: 'customerMaterials/index',
        component: () => import(/* webpackChunkName: "customerMaterials" */ '@/views/module/product/customerMaterials/index.vue'),
        name: 'vcCustomerMaterials',
        meta: {
          title: 'customerMaterials',
          icon: '#iconcaidanitem',
          roles: ['MENU_vcCustomerMaterials']
        }
      }
    ]
  }
]
export default productMainRouter
